import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Table,
  IconButton,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Button,
  Paper,
  TableContainer,
} from "@mui/material";
import apiClient from "./api/apiClient";
import {ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import NotificationDialog from "./NotificationDialog";

const GeneratePassword = () => {
  const navigate = useNavigate();
  const [dialogOpen,setDialogOpen] = useState(false);
  const [severity,setSeverity] = useState("");
  const [message,setMessage] = useState("");
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState({});

  // Fetch users from backend
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await apiClient.get("/users"); // adjust endpoint
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const handleCheckboxChange = (id) => {
    setSelectedUsers((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleGenerate = async () => {
    const selected = users
      .filter((user) => selectedUsers[user.id])
      .map(({ id, name, email }) => ({ id, name, email }));

    try {
      const response = await apiClient.post("/userpassword/generatepasswords", selected); // adjust endpoint
/*      setDialogOpen = true;
      setSeverity("Success");
      setMessage("Password Generated Successfully!");*/
      console.log(response.data);
      alert("Password Generated Successfully");
    } catch (error) {
      console.error("Error generating passwords:", error);
/*      setDialogOpen = true;
      setSeverity("Error");
      setMessage("Password Could Not be generated, Error: "+error);*/
    }
  };

  const handleClose = () => {
    console.log("Close clicked");
  };
  const handleBack = () => {
    navigate(-1); // Navigate to previous screen
  };
  return (
      <Box sx={{ width: "100%", mt: 5 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
             <IconButton onClick={handleBack}>
                <ArrowBack />
              </IconButton>
              <Typography variant="h5" sx={{ ml: 1 }}>
                 Generate Password
              </Typography>
            </Box>
      <Box sx={{ width: "90%", mx: "auto" }}>
      <TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: "auto" }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email ID</TableCell>
                <TableCell align="center">Select</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.email}</TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={!!selectedUsers[user.id]}
                      onChange={() => handleCheckboxChange(user.id)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 3 }}>
          <Button variant="contained" color="primary" onClick={handleGenerate}>
            Generate
          </Button>
        </Box>
      </Box>
      <NotificationDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        message={message}
        severity={severity}  // other options: "info", "error", "warning"
      />
    </Box>
  );
};

export default GeneratePassword;
